import { Button, TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { renderStatusColor, renderStatusName } from 'utils/statusHelper';
import { useState } from 'react';
import { RejectHistory } from 'components/dialog/RejectHistory';

export const TemplatesTableRow = ({ row, index }) => {
  const [openRejectHistory, setOpenRejectHistory] = useState(false);
  const { userID, host, config, status, createdAt, _id, type, userData } = row;

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{row?.title || 'عنوان نامشخص'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{userID}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>
            {userData ? (
              <>
                {userData?.isVerified ? (
                  <SvgIconStyle src="/icons/green_check.svg" sx={{ color: '#1FB23F' }} />
                ) : (
                  <SvgIconStyle src="/icons/info_circle_icon.svg" sx={{ color: 'red' }} />
                )}
              </>
            ) : (
              '---'
            )}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>
            {userData ? (
              <>
                {userData?.maintain === '1' ? (
                  <SvgIconStyle src="/icons/green_check.svg" sx={{ color: '#1FB23F' }} />
                ) : (
                  <SvgIconStyle src="/icons/info_circle_icon.svg" sx={{ color: 'red' }} />
                )}
              </>
            ) : (
              '---'
            )}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{config?.support?.phones.map((p) => p)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{config?.address?.plain || '---'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{type === 1 ? 'فروشگاهی' : 'شخصی'}</Typography>
        </TableCell>
        <TableCell align="left">
          <a
            href={`https://${status !== 4 ? host : host.split('!')[2]}.aff.bizmlm.ir`}
            target="_blank"
            rel="noreferrer"
          >
            <Typography>{status !== 4 ? host : host.split('!')[2]}</Typography>
          </a>
        </TableCell>
        <TableCell align="left">
          <Typography color={renderStatusColor(status)}>{renderStatusName(status)}</Typography>
        </TableCell>
        <TableCell align="left">
          {[3, 4].includes(status) ? (
            <Button
              variant="contained"
              color={status === 3 ? 'success' : 'error'}
              onClick={() => setOpenRejectHistory(true)}
            >
              مشاهده
            </Button>
          ) : (
            '-'
          )}
        </TableCell>
        <TableCell align="left">
          <div
            aria-hidden
            onClick={() => window?.open(`/dashboard/request/${type === 1 ? 'detail' : 'cvDetail'}/${_id}`, '_blank')}
          >
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
      <RejectHistory
        open={openRejectHistory}
        onClose={() => setOpenRejectHistory(false)}
        content={status === 3 ? row?.activation : row?.deactivation}
        status={status}
      />
    </>
  );
};
